import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged, IMyInputFocusBlur, MyDatePicker } from 'mydatepicker';



@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DatePickerComponent implements OnInit {
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showTodayBtn: false,
    showClearDateBtn: false,
    editableDateField: true,
    openSelectorOnInputClick: false
  };

  @Output() dateChanged = new EventEmitter<any>();
  @Output() inputFocusBlur = new EventEmitter<any>();
  @Output() inputFieldChanged = new EventEmitter<any>();
  @ViewChild('mydp') public datePicker: MyDatePicker;

  constructor() { }

  ngOnInit() {
  }

  /**
   * @param event
   * event.date: Date object in the following format: { day: 22, month: 11, year: 2016 }
   * event.jsdate: Javascript Date object
   * event.formatted: Date string in the same format as dateFormat option is: '2016-11-22'
   * event.epoc: Epoc time stamp number: 1479765600
   */
  onDateChanged(event: IMyDateModel) {
    this.dateChanged.emit(event.jsdate);
  }

  /**
   * @param event
   * event.reason: Reason of the event:
   * 1 = focus to input box
   * 2 = focus out of input box
   * event.value: Value of input box
   */
  onInputFocusBlur(event: IMyInputFocusBlur) {
    if (event.reason === dateInputFocus.FOCUSOUT) {
      this.inputFocusBlur.emit(event);
    }
  }

  /**
   * @param event
   * event.value: Value of the input field. For example: '2016-11-22'
   * event.dateFormat: Date format string in the same format as dateFormat option is. For example: 'yyyy-mm-dd'
   * event.valid: Boolean value indicating is the input field value valid or not. For example: true
   */
  onInputFieldChanged(event: IMyInputFieldChanged) {
    this.inputFieldChanged.emit(event);
  }
}

export enum dateInputFocus {
  FOCUSIN = 1,
  FOCUSOUT = 2
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/date-picker/date-picker.component.ts